import { FC } from 'react';

import Image from './image.png';

export const RedeemImage: FC = () => <img src={Image} alt="redeem" />;
